import React, { Component } from 'react';
// Step 1a : connect component to redux
import { connect } from 'react-redux';

class Counter extends Component {
  increment() {
    // Step 7a: use dispatch()
    // connect injects dispatch() as a prop
    this.props.dispatch({type: "INCREMENT"})
  }

  decrement() {
    // Step 7b: use dispatch()
    // connect injects dispatch() as a prop
    this.props.dispatch({type: "DECREMENT"})
  }

  render() {
    return (
      <div className="container center flow-text">
        <h4>Basic React + Redux Counter</h4>
        <div>
          <button className="btn waves-effect" onClick={this.decrement.bind(this)}>&ndash;</button>
          &nbsp;
          <span>{this.props.count}</span>
          &nbsp;
          <button className="btn waves-effect" onClick={this.increment.bind(this)}>+</button>
        </div>
        <p>This app demonstrate a React component that uses redux.
          <br/>
          <a href="https://github.com/kurapikats/react-redux"
            target="_blank" rel="noopener noreferrer">
            Source is available here</a></p>
      </div>
    );
  }
}

// Step 2b: map the state to props
const mapStateToProps = (state) => ({
  count: state.count
})

// Step 1b : currying
// Step 2b : pass it connect()
export default connect(mapStateToProps)(Counter);



// WEBPACK FOOTER //
// ./src/Counter.js